import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap5';
import { Link } from 'react-router-dom';

import routes from 'app/routes';
import ExternalLink from 'components/Widgets/ExternalLink';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { useContext as usePlansContext } from 'components/Managers/Policy/Context';

import Plans from './List/Index';

export default function Index() {
  const { dispatch: dispatchPlans, actions: actionsPlans, state: statePlans } = usePlansContext();

  useEffect(() => {
    actionsPlans.load(dispatchPlans);
  }, []);

  return (
    <div className="content">
      <section>
        <Row className="mb-3">
          <Col>
            <h1>Your Talent Insurance Policy</h1>
          </Col>

          <Col xs="12" lg="auto">
            <ExternalLink
              href="https://meetings.hubspot.com/viktor-bullain"
              className="btn-reverse mt-2 mt-lg-0 me-2 me-sm-3"
            >
              Contact Sales
            </ExternalLink>

            <Link
              to={routes.managers.plans.new.choose_template}
              className={`btn btn-primary mt-2 mt-lg-0 ${statePlans.enterprise.attributes.is_lock ? 'disabled' : ''}`}
              disabled={statePlans.enterprise.attributes.is_lock}
            >
              Add Plan
            </Link>
          </Col>
        </Row>

        <p>
          Review the details of your policy by selecting any of the plans on the list.
        </p>
      </section>

      <section>
        {statePlans.plans === null
          ? <LoadingPlaceholder text="Loading plans..." />
          : <Plans plans={statePlans.plans} />}
      </section>

      <footer>
        <a href={routes.managers.billing.index} className="btn btn-primary">
          Go to Billing
        </a>
      </footer>
    </div>
  );
}
